module.exports = __webpack_public_path__ + "static/icon-gears-f0e21f7b712c6d7e0ca9b24df766657d.svg";